export default __webpack_public_path__ + "static/template-f1680144009be71e39c966d22aa1b05d.png";